import {useQuery} from "@tanstack/react-query";

import {householdService} from "../service";

type UseHouseholdOptions = {
  enabled?: boolean;
};

export default function useHousehold(
  id: number | undefined | null,
  options?: UseHouseholdOptions,
) {
  const queryEnabled = (options?.enabled ?? true) && Boolean(id);

  const {data, isSuccess, isPending, isError, isFetching, refetch} = useQuery({
    queryKey: ["households", {id}],
    queryFn: () => householdService.getHousehold(id!),
    enabled: queryEnabled,
    retry: false,
  });

  const household = id && isSuccess && data != null ? data : null;

  return {
    household,
    isPending: Boolean(id && queryEnabled && isPending),
    isError,
    isFetching,
    refetch,
  };
}
